var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Artboard 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1170 712c34.89 83.9 235.09 34.531 295 157 84.2 172.11-186.32 260.26-404 192-113.828-35.69-208-28.76-208-195s202.75-428.737 317-154Z",
    transform: "translate(-873 -185)",
    style: {
      fillOpacity: 0.1,
      fillRule: "evenodd",
      fill: "#fccd5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 1 copy",
    d: "M2851 618c-102.11 424.32-264.22 253.077-391 199-139.08-59.325-28.92-199.4-88-267-85.85-98.236-332.65 77.913-412-57-107.93-183.517-24.1-295.906 288-334 307.39-37.519 698.87 60.61 603 459Z",
    transform: "translate(-873 -185)",
    style: {
      fill: "#52b2d5",
      fillOpacity: 0.1,
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.237ec7be69bbd7b547b8fa3adfea9347.svg";
export { ForwardRef as ReactComponent };